import { ArrowRight } from '@berlitz/icons'
import { getRoutingAdapter } from '@shell/adapters/routing'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Col, Row } from 'react-styled-flexboxgrid'
import { Back, Body } from './style'

/* TODO: Add button with right icon to max
 */
interface IBackButton {
  onClick?: Function
  back?: string
}

const BackButton: React.FC<IBackButton> = ({ onClick, back }) => (
  <Body fluid>
    <Row>
      <Col>
        <Back
          onClick={() => {
            if (onClick) return onClick()
            if (back) return void getRoutingAdapter().navigate(back)
            return void getRoutingAdapter().back()
          }}
        >
          <ArrowRight />
          <FormattedMessage id="back" defaultMessage="Back" />
        </Back>
      </Col>
    </Row>
  </Body>
)

export default BackButton
